var style = {"z-autoshipment-logo-lockup":"z-autoshipment-logo-lockup","z-autoshipment-logo-lockup--medium":"z-autoshipment-logo-lockup--medium","z-autoshipment-logo-lockup--light":"z-autoshipment-logo-lockup--light"};

export { style as default };
//# sourceMappingURL=AutoshipmentLogoLockup.module.scss.js.map
